import Link from "next/link";

import { BreadcrumbJsonLd } from "next-seo";

import { SITE_DOMAIN } from "@/lib/constants";
import { cn } from "@/lib/utils";

const Breadcrumbs = ({
  className,
  industry,
  industrySlug,
}: {
  className?: string;
  industry: string;
  industrySlug: string;
}) => {
  const breadcrumbItems = [
    {
      position: 1,
      name: "Home",
      item: SITE_DOMAIN,
    },
    {
      position: 2,
      name: "Web Design",
      item: `${SITE_DOMAIN}/web-design`,
    },
    {
      position: 3,
      name: industry,
      item: `${SITE_DOMAIN}/web-design/${industrySlug}`,
    },
  ];

  return (
    <div className={cn("w-full", className)}>
      <BreadcrumbJsonLd itemListElements={breadcrumbItems} />
      <nav aria-label="Breadcrumb" className="container mx-auto">
        <ol className="flex items-center space-x-2 text-sm text-ash-500">
          <li>
            <Link href="/" className="hover:text-ash-700">
              Home
            </Link>
          </li>
          <li className="">/</li>
          <li className="text-center">
            <span className="cursor-default">Web Design</span>
          </li>
          <li className="">/</li>
          <li className="text-center">
            <span className="text-ash-900 cursor-default">{industry}</span>
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumbs;
